"use strict";

var ensureValue   = require("./valid-value")
  , stringifiable = require("./validate-stringifiable");

module.exports = function (value) {
	return stringifiable(ensureValue(value));
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/validate-stringifiable-value.js
// module id = 239
// module chunks = 0